function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackLoopArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 102 158",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-1024.27,-399.678)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,218.967,-964.728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4134.7,3152.93L4215.37,3129.66C4229.07,3125.71 4243.39,3133.62 4247.34,3147.31C4251.3,3161.01 4243.38,3175.34 4229.69,3179.29L4171.19,3196.16L4188.78,3254.7C4192.89,3268.36 4185.13,3282.77 4171.48,3286.87C4157.83,3290.97 4143.42,3283.22 4139.32,3269.57L4115.56,3190.49C4114.81,3189.04 4114.2,3187.49 4113.73,3185.86C4110.73,3175.48 4114.55,3164.74 4122.54,3158.43C4125.1,3156.33 4128.1,3154.7 4131.46,3153.69C4132.54,3153.36 4133.62,3153.11 4134.7,3152.93Z",
    style: {
      fill: "rgb(212,215,221)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.990956,0.134185,-0.134185,-0.990956,9108.56,4365.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4134.7,3152.93L4215.37,3129.66C4229.07,3125.71 4243.39,3133.62 4247.34,3147.31C4251.3,3161.01 4243.38,3175.34 4229.69,3179.29L4171.19,3196.16L4188.78,3254.7C4192.89,3268.36 4185.13,3282.77 4171.48,3286.87C4157.83,3290.97 4143.42,3283.22 4139.32,3269.57L4115.56,3190.49C4114.81,3189.04 4114.2,3187.49 4113.73,3185.86C4110.73,3175.48 4114.55,3164.74 4122.54,3158.43C4125.1,3156.33 4128.1,3154.7 4131.46,3153.69C4132.54,3153.36 4133.62,3153.11 4134.7,3152.93Z",
    style: {
      fill: "rgb(212,215,221)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.833684,0.119146,0.119146,0.833684,4678.81,2194.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,38.382C28.085,46.491 56.849,50.336 85.168,50.376C113.495,50.418 141.395,46.672 167.934,39.617C194.473,32.563 219.66,22.189 242.545,9.008C265.433,-4.164 285.996,-20.158 303.333,-38.222C323.102,-58.82 355.824,-59.492 376.422,-39.724C397.02,-19.956 397.692,12.767 377.924,33.364C374.896,36.52 371.564,39.207 368.017,41.426L365.958,42.684C336.342,60.971 304.743,74.485 272.575,83.498C240.393,92.515 207.614,97.07 175.26,97.475C142.905,97.874 110.948,94.116 80.413,86.387C49.884,78.664 20.776,66.933 -5.669,51.54C-9.114,49.535 -10.28,45.118 -8.276,41.674C-6.577,38.756 -3.146,37.472 -0.042,38.368L0,38.382Z",
    style: {
      fill: "rgb(212,215,221)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.742729,-0.26286,-0.26286,-0.742729,4286.92,1837.43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,38.382C28.085,46.491 56.849,50.336 85.168,50.376C113.495,50.418 141.395,46.672 167.934,39.617C194.473,32.563 219.66,22.189 242.545,9.008C265.433,-4.164 285.996,-20.158 303.333,-38.222C323.102,-58.82 355.824,-59.492 376.422,-39.724C397.02,-19.956 397.692,12.767 377.924,33.364C374.896,36.52 371.564,39.207 368.017,41.426L365.958,42.684C336.342,60.971 304.743,74.485 272.575,83.498C240.393,92.515 207.614,97.07 175.26,97.475C142.905,97.874 110.948,94.116 80.413,86.387C49.884,78.664 20.776,66.933 -5.669,51.54C-9.114,49.535 -10.28,45.118 -8.276,41.674C-6.577,38.756 -3.146,37.472 -0.042,38.368L0,38.382Z",
    style: {
      fill: "rgb(212,215,221)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackLoopArrows);
export default __webpack_public_path__ + "static/media/feedback_loop_arrows.edc8cd4d.svg";
export { ForwardRef as ReactComponent };